import { Kymw68FeatureCodeComboBoxComponent } from './feature-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Feature } from './feature.model';

/**
 * 特集コードコンボボックスモデル
 *
 * @export FeatureCodeComboBoxModel
 * @class FeatureCodeComboBoxModel
 */
export class FeatureCodeComboBoxModel {

  // 特集コードリスト
  public dataList: Feature[];
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setFeatureCode: string = <string>'';
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>false;
  // 媒体区分
  public mediumType: string = <string>'';
  // コンボボックスインスタンス
  public component: Kymw68FeatureCodeComboBoxComponent;


  /**
   * 特集コードリストを更新する
   *
   * @param {*} serverData 特集コードリスト取得データ
   * @memberof FeatureCodeComboBoxModel
   */
  public updateDataList(serverData: Feature[]): void {
    let tempDataList: Feature[] = [];

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = [];
      }
    }

    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      const ob = new Feature();
      tempDataList.splice(index, 0, ob);
      index = <number>1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].FeatureCodeName = tempDataList[index].FeatureCode + ':' + tempDataList[index].FeatureName;
    }

    this.dataList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedFeatureCode();
  }

}